/*
* 更新数组
* data: {
        ip: '127.0.0.1', //选择的ip
        portArray: [-1, ..., -1] //ip对应的端口
    }
*/
import TYPES from './mutation-types'
import Vue from 'vue'

export default {
  // 端口数组-start
  updateEle(state, data) {
    // state.port = data
    const index = state[data.type + 'port'].findIndex(item => item.ip == data.ip)
    if (index != -1) {
      state[data.type + 'port'][index].portArray = data.portArray
    } else {
      state[data.type + 'port'].push(data)
    }
  },
  clearEle(state) {
    state.innerport = []
    state.outerport = []
    // state.portmapVerified = []
  },
  delEle(state, data) {
    const index = state[data.type + 'port'].findIndex(item => item.ip == data.ip)
    if (index != -1) {
      state[data.type + 'port'].splice(index, 1)
    }
  },
  // 端口数组-end

  // 表单ref-start
  updateRef(state, data) {
    state.allref.push(data)
  },
  clearRef(state) {
    state.allref = []
  },
  // 表单ref-end

  //data{ data: {增加的数据}, index: num(删除的下标) }
  updatePortmapVerified(state, data) {
    // state.portmapVerified = data
    if (data.type == 'add') {
      state.portmapVerified.push(data.data)
    } else if (data.type == 'del') {
      state.portmapVerified.splice(data.index, 1)
    }
  },
  clearPortmapVerified(state) {
    state.portmapVerified = []
  },

  // 端口范围- start
  updateRangeVerified(state, data) {
    if (data.type == 'add') {
      state.rangeVerified.push(data.data)
    } else if (data.type == 'del') {
      const index = state.rangeVerified.indexOf(data.data)
      state.rangeVerified.splice(index, 1)
    }
  },
  clearRangeVerified(state) {
    state.rangeVerified = []
  },
  // 端口范围- end

  // 更新推送的消息
  updateWebsocket(state, data) {
    // state.socketInfo = data
    // console.log('收到更新id:'+ data.insId + ',progerss:' + data.progress)
    state.socketInfo = Object.assign({}, data)
  },

  // 菜单更新
  setLogin(state, data) {
    state.menus = data
  },

  // 获取当前菜单(列表页)的操作列
  //   @menuName:菜单名称
  // getListOperations(state, menuName){
  //
  //     let arr = []
  //     let menuItem = null
  //
  //     state.listOperations = []
  //     state.currentMenuOperations = []
  //
  //     if(state.menus && state.menus.length > 0){
  //         for(let menu of state.menus){
  //             if(menu.route.includes(menuName)){
  //                 menuItem = menu
  //                 state.currentMenuOperations = menu.functionList
  //                 arr = menu.functionList.filter(func => !func.name.includes('addItem'))
  //                 break
  //             }else if(menu.childrenList.length > 0){
  //                 for(let childMenu of menu.childrenList){
  //                     if(childMenu.route.includes(menuName)){
  //                         menuItem = childMenu
  //                         state.currentMenuOperations = childMenu.functionList;
  //                         arr = childMenu.functionList.filter(func => !func.name.includes('addItem'));
  //                         break
  //                     }
  //                 }
  //             }
  //         }
  //     }
  //     state.listOperations = arr
  //     state.currentMenu = menuItem
  // },
  getListOperations(state, menuName) {
    let arr = []
    let menuItem = null
    state.listOperations = []
    state.currentMenuOperations = []

    const getMenuOperations = (menus) => {
      for (let menu of menus) {
        if (menu.route.includes(menuName)) {

          menuItem = menu
          for (let func of menu.buttonList) {
            arr.push(func)
            // func.childrenList = getFunctionOperations(func.childrenList)
            if (func.buttonList && func.buttonList.length > 0) {
              arr.push(...getFunctionOperations(func.buttonList))
            }
          }
        } else if (menu.childrenList && menu.childrenList.length > 0) {
          getMenuOperations(menu.childrenList)
        }
      }
    }
    const getFunctionOperations = (functions) => {
      let arr = [];
      for (let func of functions) {

        arr.push(func)
        if (func.buttonList && func.buttonList.length > 0) {
          arr.push(...getFunctionOperations(func.buttonList))
        }
      }
      return arr
    }

    if (state.menus && state.menus.length > 0) {
      getMenuOperations(state.menus)
    }

    state.currentMenuOperations = arr
    state.listOperations = arr.filter(func => !func.name.includes('menu_add') && !func.name.includes('menu_operation'))
    state.currentMenu = menuItem
  },

  clearToken(state, data) {
    state.menus = []
    state.listOperations = []
    state.currentMenuOperations = []
    // sessionStorage.removeItem('token')
    // sessionStorage.removeItem('menus')
    localStorage.removeItem('token')
    localStorage.removeItem('menus')
  },

  // nps相关-start
  [TYPES.GET_FAST_MENU](state, {groups, appPris}) {
    let keyvalues = (groups &&
      groups.find(info => info.name === 'webbg') &&
      groups.find(info => info.name === 'webbg')
        .keyvalues.find(keyvalue => keyvalue.key === 'fastMenus')
    ) || {};
    if (Object.keys(keyvalues).length > 0) {
      state.fastMenus = appPris.filter(app => JSON.parse(keyvalues.value).findIndex(keyvalue => keyvalue === app.appKey) !== -1)
    } else {
      state.fastMenus = [];
    }
    state.isOverFastMenusLength = false;
  },
  [TYPES.SET_ACTIVE_FAST_MENU](state, menu) {
    state.activeFastMenu = menu;
  },
  [TYPES.OVER_FASTMENUS_LENGTH](state) {
    state.isOverFastMenusLength = true;
  },
  [TYPES.CHANGE_MENU_SIZE](state) {
    state.isBigMenu = !state.isBigMenu;
  },
  [TYPES.CHANGE_HOVER_MENU](sate, index) {
    sate.hoverMenu = index;
  },
  [TYPES.HIDE_MENU](state) {
    state.isHideMenu = !state.isHideMenu;
  },
  [TYPES.BIG_MENU](state) {
    state.isBigMenu = !state.isBigMenu;
  },
  [TYPES.SET_MENU_HEIGHT](state, {height, tableHeight}) {
    state.menuHeight = height;
    if (tableHeight < 300)
      tableHeight = 300;

    state.tableHeight = state.tableHeight > tableHeight ? state.tableHeight : tableHeight;
  },
  [TYPES.SET_HOME_SCROLLTOP](state, scrollTop) {
    state.homeScrollTop = scrollTop;
  },
  [TYPES.LOADING_START](state) {
    state.fullScreenLoading = true;
  },
  [TYPES.LOADING_END](state) {
    state.fullScreenLoading = false;
  },
  [TYPES.SET_SYSTEM_INFO](state, {logo, logoHover, projectName, htmlTitle}) {
    state.systemInfo = {
      logo: logo || state.systemInfo.logo,
      logoHover: logoHover || state.systemInfo.logoHover,
      projectName: projectName || state.systemInfo.projectName,
      htmlTitle: htmlTitle || state.systemInfo.htmlTitle,
      isSetted: true,
    }
  },

  /**
   * 设置上传视频
   */
  setUploadVideo(state, payload) {
    Vue.set(state.videoUploadList, payload.tempFilename, payload.fileInfo)
  },

  /**
   * 改变进度
   */
  changeProgress(state, payload) {
    let temp = state.videoUploadList
    state.videoUploadList = {}
    for (let attr in temp) {
      if (attr == payload.tempFilename) {
        Vue.set(state.videoUploadList, payload.tempFilename, payload.fileInfo)
      } else {
        Vue.set(state.videoUploadList, attr, temp[attr])
      }
    }
  },

  /**
   * 取消上传，删除文件
   */
  removeCancelFile(state, payload) {
    let temp = JSON.parse(JSON.stringify(state.videoUploadList))
    delete temp[payload]
    state.videoUploadList = temp
  },

  /**
   * 清空上传列表
   */
  clearUploadList(state, payload) {
    state.videoUploadList = {}
  },

  /**
   * 改变上传视频窗口显示状态
   */
  changeVideoBox(state, payload) {
    state.isShowVideoUpload = payload
  },

  /**
   * 设置上传窗口 最小化/最大化
   */
  changeUploadWindow(state, payload) {
    state.isMinix = payload
  },

  /**
   * 上传文件个数增加
   */
  addUploadFileNums(state, payload) {
    state.uploadFileNums++
  },

  /**
   * 重置上传文件个数
   */
  resetUploadFileNums(state, payload) {
    state.uploadFileNums = 0
  },

  /**
   * 更改当前上传文件个数
   */
  changeCurentFileNums(state, payload) {
    if (payload < 0) {
      state.currentUploadFileNums--
    } else {
      state.currentUploadFileNums++
    }
  },

  /**
   * 改变视频上传 确定按钮显示状态
   */
  changeUploadConfirm(state, payload) {
    state.isShowConfirm = payload
  },

  /**
   * 改变视频是否全部上传完成标志
   */
  set_isUploadComplete(state, payload) {
    state.isUploadComplete = payload
  }
  // nps 相关-end
}
